import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddressBook } from "./reducer";
import { getErrorMessage, isFresh } from "utils/helpers";
import apiConfig from "constants/apiConfig";
import { fetchAddress } from "services/api/collaboration";
import { fetchInfluencerAdresses } from "services/api/address";

export const fetchAddressThunk = createAsyncThunk(
    'a/address',
    async ({force=false, addressUUID}: {addressUUID: string, force?: boolean}, {getState, rejectWithValue}) => {
        const state = getState() as {addressBook: AddressBook};
        const STALE_TIME = apiConfig.FETCH_ADDRESS.staleTime
        try {
            if(!force && isFresh(state.addressBook.items[addressUUID]?.last_fetched_at, STALE_TIME)){
                return {address: state.addressBook.items[addressUUID].address, cache: true}
            }
            const address = await fetchAddress(addressUUID);
            return {address}
        } catch (error) {
            console.log(error)
            return rejectWithValue(getErrorMessage(error, "failed to fetch address"));
        }

    }
)

export const fetchInfluencerAddressesThunk = createAsyncThunk(
    'i/addresses',
    async ({influencerId, force=false}: {influencerId: string, force?: boolean}, {getState, rejectWithValue}) => {
        const state = getState() as {addressBook: AddressBook};
        const STALE_TIME = apiConfig.FETCH_INFLUENCER_ADDRESSES.staleTime
        try {
            if(!force && isFresh(state.addressBook.influencers[influencerId]?.last_fetched_at, STALE_TIME)){
                return {list: state.addressBook.influencers[influencerId].items, last_fetched_at: state.addressBook.influencers[influencerId].last_fetched_at, influencerId}
            }
            const list = await fetchInfluencerAdresses(influencerId);
            return {list, influencerId}
        } catch (error) {
            console.log(error)
            return rejectWithValue(getErrorMessage(error, "failed to fetch address book"));
        }

    }
)